import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/auth";

const LogoutRedirect = (props) => {
  const [searchParams] = useSearchParams();
  const redirectUrl = searchParams.get("redirect");

  useEffect(() => {
    // Clear session on account platform
    props.logout();

    // After logging out locally, redirect back to originating platform if provided
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      window.location.href = "/";
    }
  }, [props, redirectUrl]);

  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout())
  };
};

export default connect(null, mapDispatchToProps)(LogoutRedirect);


